export default __webpack_public_path__ + "static/media/Group8414.be0d3764.svg";